import { setMetadata } from '@sheerid/jslib';
import { GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login';
import { setGoogleOauthEmail, setGoogleOauthId, setGoogleOauthFirstName, setGoogleOauthLastName } from '../oauth/oauth';


export const handleOauthOnSuccess = (response: GoogleLoginResponse | GoogleLoginResponseOffline) => {
    const newGoogleEmail = (response as GoogleLoginResponse).getBasicProfile().getEmail();
    const newGoogleId = (response as GoogleLoginResponse).getBasicProfile().getId();
    const newGoogleFirstName = (response as GoogleLoginResponse).getBasicProfile().getGivenName();
    const newGoogleLastName = (response as GoogleLoginResponse).getBasicProfile().getFamilyName();
    setGoogleOauthEmail(newGoogleEmail);
    setGoogleOauthId(newGoogleId);
    setGoogleOauthFirstName(newGoogleFirstName);
    setGoogleOauthLastName(newGoogleLastName);
    setMetadata({
        googleEmail: newGoogleEmail,
        googleId: newGoogleId,
    });
};

